"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PROJECTS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PROJECTS = (0, gql_1.gql)(`
  query projects(
    $ids: [ID!],
    $sort: [ProjectOrderBy!],
    $after: ID,
    $first: Int
  ) {
    projects(ids: $ids, sort: $sort, first: $first, after: $after) {
      edges {
        node {
          id
          title
          createdAt
          slug
          description
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        startCursor
      }
    }
  }
`);
